import { useApi } from './useApi';
import { apiService } from '../services/api';

interface BehandelingenHeroData {
  title: string;
  subtitle?: string;
  backgroundImage?: {
    data?: {
      attributes?: {
        url?: string;
        alternativeText?: string;
      };
    };
  };
}

export const useBehandelingenHero = () => {
  const result = useApi<BehandelingenHeroData>(apiService.getBehandelingenHero);
  
  // Debug logging
  console.log('🎯 useBehandelingenHero - data:', result.data);
  console.log('🎯 useBehandelingenHero - loading:', result.loading);
  console.log('🎯 useBehandelingenHero - error:', result.error);
  
  return result;
};
